const REDIRECT_URL_KEY = 'pendingRedirectUrl';
const REDIRECT_TIMESTAMP_KEY = 'redirectTimestamp';
const REDIRECT_EXPIRY_MS = 30 * 60 * 1000; // 30 minutes in milliseconds

/**
 * Save a redirect URL with timestamp for later use after login
 * @param {string} url - The URL to redirect to after login
 */
export const saveRedirectUrl = (url) => {
  if (!url) {
    return;
  }

  const timestamp = Date.now();
  localStorage.setItem(REDIRECT_URL_KEY, url);
  localStorage.setItem(REDIRECT_TIMESTAMP_KEY, timestamp.toString());
};

/**
 * Get the saved redirect URL if it exists and hasn't expired
 * @returns {string|null} - The redirect URL or null if not found or expired
 */
export const getRedirectUrl = () => {
  const url = localStorage.getItem(REDIRECT_URL_KEY);
  const timestamp = localStorage.getItem(REDIRECT_TIMESTAMP_KEY);

  if (!url || !timestamp) {
    return null;
  }

  const now = Date.now();
  const savedTime = parseInt(timestamp, 10);

  // Check if the redirect URL has expired (30 minutes)
  if (now - savedTime > REDIRECT_EXPIRY_MS) {
    clearRedirectUrl();
    return null;
  }

  return url;
};

/**
 * Clear the saved redirect URL and timestamp
 */
export const clearRedirectUrl = () => {
  localStorage.removeItem(REDIRECT_URL_KEY);
  localStorage.removeItem(REDIRECT_TIMESTAMP_KEY);
};
